export default function GetCookie(cname: string): string | boolean {
    const name: string = `${cname}=`;
    const ca: string[] = decodeURIComponent(document.cookie).split(";");
    for (let i = 0; i < ca.length; i++) {
        let c: string = ca[i];
        while (c.charAt(0) === " ") {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }
    return false;
}